/* eslint-disable */
import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import {
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap';
import './style.scss';

export class Breadcrumb extends Component {

  constructor(props) {
    super(props);

  }

  componentWillReceiveProps(nextProps) {

  }

  getSubUrl(endIndex, array) {

    var url = '';

    for (var i = 0; i <= endIndex; i++) {
      url = url + '/' + array[i];

    }

    return url;
  }

  /*renderBreadCrumb(pathname) {

    var array = [];

    var res = pathname.substr(1, pathname.length - 1).split('/');

    for (var i = 0; i < res.length; i++) {
      if (res[i].indexOf('&') === -1) {
        array.push(this.getSubUrl(i, res));
      }

    }

    var breadcrumb = [];

    var className = '';

    let index = 0;

    array.map((url, i) => {

      if (i === array.length - 1) {
        className = 'active';
      }

      this.props.breadcrumbs.map(item => {

        if (url === item.url) {
          index++;
          url = url.replace(item.replace, '');
          if (className === '') {
            breadcrumb.push(<li><Link key={i} to={url}>{item.title}</Link></li>);
          } else {
            breadcrumb.push(<li className={className} key={i}>{item.title}</li>);
          }

        }
      });
    });

    return breadcrumb;

  }*/

  toolTip = (title) => {
    return (
      <Tooltip id='breadcrumb_tooltip' className='in tooltip-siteone'>
        <span>{title}</span>
      </Tooltip>
    );
  }

  renderBreadCrumb(items) {

    return items.map((t, i) => {
      if (t.url !== '') {
        if (t.onCustomAction) {
          return <li key={i} className={t.url==='' ? 'active' :''}>
        <span className='link' style={{
          color: '#23CCEF',
          textDecoration: 'none',
          fontSize: 15,
          cursor: 'pointer'
        }} onClick={t.onCustomAction}>{t.title}</span></li>
        } else {
        return <li key={i} className={t.url==='' ? 'active' :''}>
        <Link className='link' to={t.url}>{t.title}</Link></li>
        }
      } else {
        if (t.title.length > 50) {
      return <OverlayTrigger placement='top' overlay={this.toolTip(t.title)}>
      <li key={i} className={t.url==='' ? 'active' :''}><span>{t.title}</span></li>
      </OverlayTrigger>
        } else {
          return <li key={i} className={t.url==='' ? 'active' :''}><span>{t.title}</span></li>
        }
      }
    });

  }

  render() {

    //let items = this.renderBreadCrumb(window.location.pathname);

    /*let style = { 'display': 'none' };

    if (items.length >= 2) {
      style = { 'display': 'block' };
    }*/
    const breadcrumbs = this.props.breadcrumbs;
    const items = this.renderBreadCrumb(breadcrumbs);


    return <ul id='id-breadcrumb' className='breadcrumb'>{items}</ul>;
  }
}



// WEBPACK FOOTER //
// ./src/components/breadcrumb/breadcrumb.js